export default "__VITE_ASSET__D$gLSsNB__"